<template>
    <div class="asset-map">
        <div id="assetMap"></div>
        <div class="controler">
            <div class="asset-list-dv" v-if='assetListShow'>
                <asset-list-dv :dataList='pointList' :total='total' @fixPoi='fixPoi' @changePage='changePage'></asset-list-dv>
            </div>
            <div class="selectors">
                <key-prompt :map='map' @pointRes='getPointRes'></key-prompt>
                <unit-selector @unitChange='unitChange'></unit-selector>
                <el-select size='small' v-model="usage" style="width: 180px;height:34px;" @change="useChange">
                    <el-option v-for="item in purposeOptions" :key="item.key" :value='item.value'>
                        {{item.key}}
                    </el-option>
                </el-select>

            </div>
            <button class="button button--sm mr-1 bg-theme-1 text-white" @click="backHandle">返回</button>
        </div>
    </div>
</template>
<script>
import keyPrompt from './keyPrompt.vue'
import assetListDv from './assetListDv.vue'
import unitSelector from './unitSelector.vue'
import {getMapPointList} from '@/api/map.js'
export default {
    name:'assetMap',
    data(){
        return{
            map:null,
            keyWord:'',
            unit:'',
            usage:'',
            assetListShow:false,
            unitValue:'',
            centerPoint:{lng:'121.487899486',lat:'31.24916171'},
            purposeOptions:[
                {value:'',key:'全部类型'},
                {value:'商业',key:'商业'},
                {value:'办公',key:'办公'},
                {value:'居住',key:'居住'},
                {value:'工业',key:'工业'},
                {value:'其他',key:'其他'},
            ],
            usageTypeOptions:{
                '商业':'#FF4D4A',
                '办公':'#2661F1',
                '居住':'#3CB371',
                '工业':'#9E60F9',
                '其他':'#FFAF2B',
            },
            total:0,
            page:1,
            perPage:10,
            pointList: [],

        }
    },
    components:{
        keyPrompt,
        assetListDv,
        unitSelector,
    },
    methods:{
        backHandle(){
            this.$router.go(-1)
        },
        unitChange(val){
            this.unitValue=val[val.length-1];
        },
        useChange(){

        },
        G(id){
            return document.getElementById(id);
        },
        fixPoi(point){
            let pt = new BMapGL.Point(point.lng, point.lat);
            this.map.centerAndZoom(pt, 19);
            // this.map.setHeading(64.5);
            // this.map.setTilt(73);
        },
        changePage(val){
            this.page=val;
            this.getMapList();
        },
        // 地址解析 关键字转坐标
        addressAnalysis(key){
            // 创建地址解析器实例
            var myGeo = new BMap.Geocoder();
            myGeo.getPoint(key, function(point){
                if (point) {
                    console.log(key,point);
                }else{
                    console.log("您选择地址没有解析到结果!");
                }
            });
        },
        // 添加自定义图标
        addIcon(pointInfo){
            let point={lng:pointInfo.lng,lat:pointInfo.lat};
            var pt = new BMapGL.Point(point.lng, point.lat);
            var myIcon = new BMapGL.Icon('/img/3dmap/triangle'+pointInfo.actualUseFor+'.png', new BMapGL.Size(16, 16));
            var marker = new BMapGL.Marker(pt, {
                icon: myIcon,
                offset:new BMapGL.Size(-16,28)
            });
            this.map.addOverlay(marker);
        },
        // 添加类型标签
        addTypeLabel(pointInfo){
            let point={lng:pointInfo.lng,lat:pointInfo.lat};
            let pt = new BMapGL.Point(point.lng, point.lat);
            let colorType=this.usageTypeOptions[pointInfo.actualUseFor];
            let text=pointInfo.actualUseFor;
            let opts = {
                position : pt,    // 指定文本标注所在的地理位置
                offset   : new BMapGL.Size(-38, 0)    //设置文本偏移量
            }
            let label = new BMapGL.Label(text, opts);  // 创建文本标注对象
            label.setStyle({
                color : '#fff',
                fontSize : '12px',
                width:'40px',
                lineHeight:'23px',
                height:'26px',
                display:'block',
                textAlign:'center',
                backgroundColor:colorType,
                borderRadius:'4px 0 0 4px',
                boxShadow: "0 2px 12px 0 rgba(0,0,0,.1)",
                border:'none',
            });
            this.map.addOverlay(label);
        },
        // 添加资产名称标签
        addLabel(pointInfo){
            let text=pointInfo.certificateAddress;
            let point={lng:pointInfo.lng,lat:pointInfo.lat};
            let pt = new BMapGL.Point(point.lng, point.lat);
            let colorType=this.usageTypeOptions[pointInfo.actualUseFor];
            var opts = {
                position : pt,    // 指定文本标注所在的地理位置
                offset   : new BMapGL.Size(0, 0)    //设置文本偏移量
            }
            var label = new BMapGL.Label(text, opts);  // 创建文本标注对象
            label.setStyle({
                color : colorType,
                fontSize : '12px',
                lineHeight:'20px',
                display:'block',
                backgroundColor:'#fff',
                borderRadius:'0 4px 4px 0',
                padding:"2px 4px",
                boxShadow: "0 2px 12px 0 rgba(0,0,0,.1)",
                border:"1px solid #e6ebf5"
            });
            this.map.addOverlay(label);
        },
        getPointRes(point,keyWord){
            this.keyWord=keyWord;
            this.centerPoint=point;
            this.getMapList();
        },
        getMapList(){
            let para={
                lng:this.centerPoint.lng,
                lat:this.centerPoint.lat,
                radius:5,
                companyId:this.unitValue,
                actualUseFor:this.usage,
                page:this.page,
                perPage:this.perPage,
            }
            getMapPointList(para).then(res=>{
                let data=res.data;
                if(data.code==='000'){
                    this.pointList=data.content.list||[];
                    this.total=data.content.total;
                    this.assetListShow=this.pointList.length>0?true:false;
                    if(!this.assetListShow){
                        this.$message.warning('没有查询到任何资产')
                        return;
                    }
                    this.setMapPoint();
                }else{
                    console.log(data.desc)
                }
            })
        },
        setMapPoint(){
            let pt = new BMapGL.Point(this.centerPoint.lng, this.centerPoint.lat);
            this.map.centerAndZoom(pt, 19);
            this.map.clearOverlays();
            for(let i=0;i<this.pointList.length;i++){
                this.addLabel(this.pointList[i]);
                this.addTypeLabel(this.pointList[i]);
                // this.addIcon(this.pointList[i]);
            }
        },
        setPageHeight(){
            let html = document.documentElement;
            let body = document.body;
            let app = document.getElementById('app')
            html.style.height = body.style.height = app.style.height = '100%';
            body.style.padding=0;
        }

    },
    created(){

    },
    mounted(){
        this.setPageHeight();
        let map = new BMapGL.Map("assetMap");
        this.map=map;
        map.centerAndZoom(new BMapGL.Point(this.centerPoint.lng, this.centerPoint.lat), 19);
        map.enableScrollWheelZoom(true);
        map.setHeading(64.5);
        map.setTilt(73);

    },
    destroyed(){
        let html = document.documentElement;
        let body = document.body;
        let app = document.getElementById('app')
        html.style.height = body.style.height = app.style.height = '';
    }
}
</script>
<style lang='scss'>
.asset-map{
    .ant-select-selection--single{
        height:34px;
    }
    .ant-input{
        height:34px;
    }
}
</style>

<style lang="scss" scoped>
.asset-map{
    width:100%;
    height:100%;
    background-color:#F1F5F8;
    #assetMap{
        width:100%;
        height:100%;
    }
    .controler{
        background-color:rgba(27,137,212,0.6);
        padding-left:20px;
        padding-right: 20px;
        box-sizing: border-box;
        position:fixed;
        z-index: 10;
        top:0;
        left:0;
        right:0;
        height: 66px;
        display:flex;
        align-items: center;
        justify-content: space-between;
        .asset-list-dv{
            position: absolute;
            top:54px;
            left:20px;
            border-radius:2px;
        }
        h2{
            position:absolute;
            left:50%;
            top:0;
            font-size: 20px;
            font-weight: 600;
            line-height: 60px;
            margin:0;
            color:#fff;
        }
        .selectors{
            display:flex;
            align-items:center;
        }
        .notice{
            display:flex;
            align-items: center;
            cursor: pointer;
            .re{
                width:16px;
                height:16px;
            }
            i{
                color:#fff;
                margin-left:6px;
            }
        }
    }
}
</style>


